



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { HttpService } from "@/services/api/httpService";
import { CommunicationType } from "@/types/communicationType";
@Component
export default class CommunicationTypeList extends Vue {
  total = 10;
  searchCriteria: string = "";
  httpServiceArray = new HttpService<Array<CommunicationType>>();
  httpService = new HttpService<CommunicationType>();
  pageSize: any = localStorage.getItem("pageSize")
    ? localStorage.getItem("pageSize")
    : 25;
  pageNumber: number = 1;
  responseArray: Array<CommunicationType> = new Array<CommunicationType>();
  showModal: boolean = false;
  removeData: CommunicationType = new CommunicationType();

  getList() {
    this.httpServiceArray
      .getListSearch(
        "communicationTypes",
        this.pageSize,
        this.pageNumber,
        this.searchCriteria
      )
      .then(response => {
        if (response.status != 404) {
          this.responseArray = response.data;
          //this.total = JSON.parse(response.headers["x-pagination"]).totalCount; //TODO when API returns the totalCount in the headers we can implement this.
        } else this.responseArray = new Array<CommunicationType>();
      });
  }
  reset() {
    this.searchCriteria = "";
    this.getList();
  }
  @Watch("pageSize", { immediate: true }) onPageSize() {
    localStorage.setItem("pageSize", this.pageSize);
    this.getList();
  }
  @Watch("pageNumber") onPageChange() {
    this.getList();
  }
  created() {
    this.getList();
  }

  add() {
    this.$router.push({
      name: "communicationTypesAdd"
    });
  }
  confirmRemove(data: CommunicationType) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: CommunicationType) {
    await this.httpService
      .deleteItem("communicationTypes", data.communicationTypeId)
      .then(response => {
        this.responseArray = this.responseArray.filter(
          (item: CommunicationType) =>
            item.communicationTypeId != data.communicationTypeId,
          this.$notification.success(
            `${data.communicationTypeName} successfully removed!`
          )
        );
      });
    this.showModal = false;
    this.getList();
  }
  edit(data: CommunicationType) {
    this.$router.push({
      name: `communicationTypesEdit`,
      params: { id: data.communicationTypeId }
    });
  }
}
